export default __webpack_public_path__ + "42bd4aefbeeaf09002f38fb3c4dd633f.png";